import { BrandToApi } from './brandToApi';
import { CheckboxToApi } from './checkboxToApi';
import { RangeToApi } from './rangeToApi';
import { TextToApi } from './textToApi';
import { Schema } from 'effect';

import { TaxonToApi } from './taxonToApi';
import { WarehouseToApi } from './warehouseToApi';

export const AllFilterStateMapsToApi = Schema.Struct({
  checkboxFilters: CheckboxToApi,
  textFilters: TextToApi,
  rangeFilters: RangeToApi,
  brands: BrandToApi,
  warehouses: WarehouseToApi,
  taxons: TaxonToApi,
});

export type AllFilterStateMapsToApi = Schema.Schema.Type<typeof AllFilterStateMapsToApi>;
